import { render, staticRenderFns } from "./WQtypeCheckbox.vue?vue&type=template&id=8c5cb29c&"
import script from "./WQtypeCheckbox.vue?vue&type=script&lang=ts&"
export * from "./WQtypeCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports